
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/auth-provider";

const ProfileSetup = () => {
  const { user, loading } = useAuth();
  const [userId] = useState<string | null>(user?.id || null);
  
  const handleSkip = () => {
    // The navigation will be handled automatically by AuthProvider
    console.log('ProfileSetup: User chose to skip profile completion');
  };

  if (loading) {
    return (
      <div className="container max-w-3xl px-4 py-4 md:px-4 md:py-8">
        <div className="flex items-center justify-center h-full">
          <p>Loading profile setup...</p>
        </div>
      </div>
    );
  }

  // This page should only be accessible if the user doesn't have a profile
  // If they do, AuthProvider will automatically redirect them
  
  return (
    <div className="container max-w-3xl px-4 py-4 md:px-4 md:py-8">
      <div className="flex items-center justify-center">
        <Card className="w-full max-w-md p-6 sm:p-8 bg-white shadow-lg border-0">
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
              Complete Your Profile
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              You can complete your profile now or skip for later
            </p>
          </div>

          <div className="mt-8 space-y-4">
            <Button
              onClick={handleSkip}
              variant="outline"
              className="w-full"
            >
              Skip for now
            </Button>
          </div>

          {userId && (
            <p className="text-xs text-gray-400 mt-8 text-center">
              User ID: {userId}
            </p>
          )}
        </Card>
      </div>
    </div>
  );
};

export default ProfileSetup;
